import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4" data-id="element-77">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl p-8 md:p-12 text-center shadow-lg border border-gold/20 relative overflow-hidden" data-id="element-78">
        <div className="absolute -right-10 -top-10 text-gold/5" data-id="element-79">
          <ShieldCheck className="w-64 h-64" data-id="element-80" />
        </div>
        <div className="relative z-10" data-id="element-81">
          <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-82">
            <ShieldCheck className="w-8 h-8 text-gold" data-id="element-83" />
          </div>
          <h2 className="font-serif text-3xl text-brown font-bold mb-6" data-id="element-84">
            Garantía de 7 días
          </h2>
          <p className="font-sans text-lg text-brown/80 leading-relaxed max-w-2xl mx-auto" data-id="element-85">
            Leelo, aplicalo, y si en una semana no sentís que tu forma de
            hablarte empezó a cambiar, nos escribís y te devolvemos el 100%. El
            riesgo lo ponemos nosotros, no vos.
          </p>
        </div>
      </div>
    </section>;
}